<style lang="less" scoped>
/deep/.bcz-modal-global {
  margin-top: -200px;
}
.bcz-modal-global-content {
  margin: 10px 0;
}
</style>
<template>
  <v-dialog
    v-model="visible"
    scrollable
    persistent
    :width="width"
    overlay-opacity="0.5"
    content-class="bcz-modal-global"
  >
    <v-card>
      <v-card-title> 
        <v-icon
          v-show="title&&icon"
          medium
          style="margin-right:5px"
          :color="icon_color"
        >
          {{ icon }}
        </v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text
        v-if="render"
        class="bcz-modal-global-content"
      >
        <ModalExpand
          :render="render"
          :cancel="cancel"
        />
      </v-card-text>
      <v-card-text
        v-else
        class="bcz-modal-global-content"
      >
        {{ content }}
      </v-card-text>
      <v-card-actions style="justify-content: flex-end ">
        <div>
          <v-btn
            v-show="showCancel"
            text
            @click="cancel"
          >
            {{ cancelText }}
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="lloading"
            @click="ok"
          >
            {{ okText }}
          </v-btn>            
        </div>
      </v-card-actions>
    </v-card> 
  </v-dialog>
</template>

<script>
  import ModalExpand from './expand'
  export default {
    components: { ModalExpand },
    props: {
      showCancel: {
        type:Boolean,
      },
      width: {
        type: Number,
        default: () => 416
      },
      okText: {
        type: String,
        default: () => '确定'
      },
      cancelText: {
        type: String,
        default: () => '取消'
      },
      content: {
        type: String,
        default: () => ''
      },
      visible: {
        type:Boolean,
        default: () => false
      },
      title: {
        type:String,
        default: () => ''
      },
      icon: {
        type:String,
        default: () => ''
      },
      icon_color: {
        type: String
      },
      loading: {
        type: Boolean,
        default: () => false
      },
      closable: {
        type: Boolean,
        default: () => false
      },
      render: {
        type: Function,
      }
    },
    data() {
      return {
        lloading: false
      }
    },
    mounted() {
      if (this.closable) {
        window.addEventListener('keyup', this.cancel)
      }
    },
    destroyed() {
      if (this.closable) {
        window.removeEventListener(this.cancel)
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      ok() {
        if (this.loading) {
          this.lloading = true
        }
        this.$emit('ok', this.stopLoading)
      },
      // 停止loading
      stopLoading() {
        this.lloading = false
      }
    }
  }
</script>